
<div class="rowScreenColPhone">

	<div></div>

	<mat-spinner diameter=30 *ngIf="bLoading" />

	<button
		mat-raised-button
		color="primary"
		[disabled]="bLoading"
		(click)="showCreationDialog()"
	>
		Neue Kategorie
	</button>

</div>


<div
	*ngIf="!elements.length && !bLoading"
	class="noElements"
	style="text-align: center;"
>
	<span>Keine Kategorien vorhanden</span>
</div>

<div
	[ngStyle]="{opacity: (elements.length ? 1 : 0)}"
	style="max-width: 50em; margin: 20px auto; "
>
	<mat-form-field appearance="outline" style="width: 100%;">
		<mat-label>Filter</mat-label>
		<input
			matInput
			placeholder="abc"
			(keyup)="applyFilter($event)"
		>
		<mat-icon matSuffix>search</mat-icon>
	</mat-form-field>

	<div class="heightPanelSmall">

		<table
			mat-table
			multiTemplateDataRows
			[dataSource]="dataSource"
			class="mat-elevation-z8"
			style="width: 100%;"
		>

			<ng-container matColumnDef="name">
				<th mat-header-cell *matHeaderCellDef>
					Name
				</th>
				<td mat-cell *matCellDef="let element">
					{{element.name}}
				</td>
			</ng-container>

			<ng-container matColumnDef="expandedDetail">
				<td mat-cell *matCellDef="let element" [attr.colspan]="columnsDisplayed.length">
					<div
						class="element-detail"
						[@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
					>
						<div class="element-description">

							<app-document-exchange-category-editor
								*ngIf="(element == expandedElement) || (element == expandedElementPrev)"
								[group]="element"
							/>

							<div style="display: flex; flex-flow: row nowrap; justify-content: flex-end;">
								<button
									mat-raised-button
									color="warn" 
									(click)="clicDelete(element)" 
									[disabled]="bDeleting"
								>
									<span class="material-icons">delete</span>
									Löschen
								</button>
							</div>

						</div>
					</div>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="columnsDisplayed"></tr>
			<tr
				mat-row
				*matRowDef="let element; columns: columnsDisplayed;"
				class="element-row"
				[class.element-expanded-row]="expandedElement === element"
				(click)="clickOnRow(element)"
			></tr>
			<tr
				mat-row
				*matRowDef="let row; columns: ['expandedDetail']" 
				class="element-detail-row"
			></tr>

			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell" [attr.colspan]="columnsDisplayed.length">
					Keine Kategorie entspricht dem Filter
				</td>
			</tr>

		</table>

	</div>
</div>

